import { Injectable } from '@angular/core';
import {
  CanDeactivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfirmDeactivateGuardGuard implements CanDeactivate<unknown> {
  constructor(private router: Router) {}

  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const navObject = this.router.getCurrentNavigation();
    console.log('navObject: ', navObject);
    if (
      navObject &&
      navObject.extras.state &&
      navObject.extras.state.bypassConfirmation
    ) {
      return true;
    }

    return window.confirm(
      '¿Está seguro/a de que desea salir? Se perderán los cambios no guardados'
    );
  }
}
